import {
  fetchMoreRecommendationsFulfilled,
  fetchMoreRecommendationsPending,
  fetchMoreRecommendationsRejected,
} from '../../actions/recommendations';
import { prepareRecommendations } from '../../mappers/prepareRecommendations';
import {
  TGetFavoritesRecommendationsResponse,
  fetchGetFavoritesRecommendations,
} from '../../repositories/favorites/v1/get-favorites-recommendations';
import { TThunkAction } from '../../types/redux';

export interface IRequestQuery {}

export const getMoreRecommendations =
  (): TThunkAction<Promise<void>> =>
  async (dispatch, getState, { httpApi, logger }) => {
    const state = getState();

    const { recommendations } = state;

    const nextPage = recommendations.page + 1;

    dispatch(fetchMoreRecommendationsPending());

    try {
      const { statusCode, response }: TGetFavoritesRecommendationsResponse = await fetchGetFavoritesRecommendations({
        httpApi,
        parameters: {
          page: nextPage,
          category: 'all',
        },
      });

      if (statusCode === 200) {
        dispatch(
          fetchMoreRecommendationsFulfilled({
            data: prepareRecommendations(response.items),
            hasMore: !!response.canLoadMore,
            page: nextPage,
          }),
        );
      }

      if (statusCode === 400) {
        dispatch(fetchMoreRecommendationsRejected());

        logger.warning(response.message || 'Failed to get Recommendations (400 status code)');
      }
    } catch (e) {
      dispatch(fetchMoreRecommendationsRejected());

      logger.error(e, { description: 'Failed to get Recommendations' });
    }
  };
